module.exports = __webpack_public_path__ + "img/word.8432a878.png";